import React, { useEffect, useState } from "react";

function diff(target) {
  if (!target) return null;
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t)) return null;
  if (t <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  return {
    d: Math.floor(t / 86400000),
    h: Math.floor(t / 3600000) % 24,
    m: Math.floor(t / 60000) % 60,
    s: Math.floor(t / 1000) % 60,
    done: false,
  };
}

export function LotteryCountdown({ target, compact }) {
  const [c, setC] = useState(() => diff(target));
  useEffect(() => {
    setC(diff(target));
    const id = setInterval(() => setC(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) {
    return (
      <div data-testid="lottery-countdown-none" className="text-sm text-zinc-400">
        Prossima estrazione: <span className="text-zinc-200 font-medium">da definire</span>
      </div>
    );
  }
  if (!c || c.done) {
    return (
      <div data-testid="lottery-countdown-done" className="text-amber-400 font-semibold">
        Estrazione in corso…
      </div>
    );
  }
  const boxes = [["Giorni", c.d], ["Ore", c.h], ["Min", c.m], ["Sec", c.s]];
  return (
    <div data-testid="lottery-countdown" className="flex gap-2 sm:gap-3">
      {boxes.map(([lbl, v]) => (
        <div key={lbl}
          className={`flex flex-col items-center rounded-lg bg-black/40 border border-amber-500/25 ${compact ? "px-3 py-2 min-w-[52px]" : "px-4 py-3 min-w-[66px]"}`}>
          <span className={`font-mono font-bold text-amber-400 tabular-nums ${compact ? "text-xl" : "text-3xl"}`}>
            {String(v).padStart(2, "0")}
          </span>
          <span className="text-[10px] uppercase tracking-wider text-zinc-500">{lbl}</span>
        </div>
      ))}
    </div>
  );
}
